import { ReactNode } from 'react';

import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import type { DataTableColumn } from '~/components/DataView/DataTable/utils/types';

import { getCellContent } from '../utils/helper';

type DataTableBodyProps<TRow extends Record<string, unknown>> = {
  columns: Array<DataTableColumn<TRow>>;
  sortedRows: TRow[];
  getRowId: (row: TRow, index: number) => string | number;
  isLoading: boolean;
  shouldShowEmptyState: boolean;
  emptyState: ReactNode;
};

const DataTableBody = <TRow extends Record<string, unknown>>({
  columns,
  sortedRows,
  getRowId,
  isLoading,
  shouldShowEmptyState,
  emptyState,
}: DataTableBodyProps<TRow>) => (
  <TableBody>
    {shouldShowEmptyState && (
      <TableRow>
        <TableCell colSpan={columns.length} sx={{ px: 2, py: 6 }}>
          {emptyState}
        </TableCell>
      </TableRow>
    )}

    {!isLoading &&
      sortedRows.map((row, rowIndex) => {
        const rowKey = getRowId(row, rowIndex);

        return (
          <TableRow hover key={String(rowKey)}>
            {columns.map((column) => (
              <TableCell
                key={`${String(column.id)}-${rowKey}`}
                align={column.align}
              >
                {getCellContent(row, column)}
              </TableCell>
            ))}
          </TableRow>
        );
      })}
  </TableBody>
);

export default DataTableBody;
